export default "<nz-card [nzBordered]=\"false\">\n    <ng-content></ng-content>\n</nz-card>\n";